import create from './create'
import deleteLang from './delete'

export default {
    create,
    'delete': deleteLang
}